<div class="row">
  <div class="col-sm-12">
    <div class="row">
      <div class="col-sm-12">
        <p class="text-primary-color text-center">Selecione uma ou mais companhias para poder exportar o relatório de histórico</p>
      </div>
      <div class="col-sm-12 mt-2 mb-4">
        <nz-select
          nzMode="multiple"
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Selecione uma ou mais companhias"
          [nzLoading]="carregandoEntidades"
          [(ngModel)]="entidadeIdsSelecionadas"
          style="width: 100%;">
          <nz-option *ngFor="let entidade of entidadesOptions" [nzValue]="entidade.id" [nzLabel]="entidade.nome"></nz-option>
        </nz-select>
      </div>
      <div class="col-sm-12 text-center mt-3">
        <button nz-button nzType="text" type="button" [nzSize]="'large'" class="btn-exportar-icone" nz-popover
                  [nzPopoverContent]="podeExportar ? 'Exportar Excel' : 'Selecione ao menos uma companhia para exportar'"
                  [disabled]="!podeExportar" (click)="exportarExcel()">
          <span nz-icon nzType="file-excel" nzTheme="outline"></span>
        </button>
        <button nz-button nzType="text" type="button" [nzSize]="'large'" class="btn-exportar-icone mx-4" nz-popover
                  [nzPopoverContent]="podeExportar ? 'Exportar Pdf' : 'Selecione ao menos uma companhia para exportar'"
                  [disabled]="!podeExportar" (click)="exportarPdf()">
          <span nz-icon nzType="file-pdf" nzTheme="outline"></span>
        </button>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col text-center">
        <button nz-button nzType="default" type="button" class="px-5" (click)="fecharModal()">Cancelar</button>
      </div>
    </div>
  </div>
</div>
